<div class="eau-loader-spinner" [class.eau-loader-spinner--inline]="inline">
    <div class="eau-loader-spinner--rect eau-loader-spinner--rect1"></div>
    <div class="eau-loader-spinner--rect eau-loader-spinner--rect2"></div>
    <div class="eau-loader-spinner--rect eau-loader-spinner--rect3"></div>
    <div class="eau-loader-spinner--rect eau-loader-spinner--rect4"></div>
    <div class="eau-loader-spinner--rect eau-loader-spinner--rect5"></div>
</div>
